module.exports = __webpack_public_path__ + "static/media/discover-incentives.b5fabe40.svg";